import { getCookie } from '../../../lib/cookies';

export interface GravityTokenClaims {
  iss?: string;
  iat?: number;
  exp?: number;
  uid?: string;
  status?: string;
  plan?: string;
  region?: string;
  orgId?: string;
  org_id?: string;
}

type Base64Buffer = { toString: (encoding: 'utf8') => string };
type BufferLike = { from: (input: string, encoding: 'base64') => Base64Buffer };

function decodeBase64(value: string): string | null {
  const atobFn = (globalThis as { atob?: (input: string) => string }).atob;
  if (typeof atobFn === 'function') {
    return atobFn(value);
  }

  const buffer = (globalThis as { Buffer?: BufferLike }).Buffer;
  if (buffer) {
    return buffer.from(value, 'base64').toString('utf8');
  }

  return null;
}

export function getGravityTokenClaimsFromToken(token: string | null | undefined): Partial<GravityTokenClaims> | null {
  if (!token) return null;

  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const decoded = decodeBase64(parts[1]);
    if (!decoded) return null;
    return JSON.parse(decoded) as Partial<GravityTokenClaims>;
  } catch {
    return null;
  }
}

export function getGravityTokenClaimsFromCookie(cookieName = 'gravity_token'): Partial<GravityTokenClaims> | null {
  return getGravityTokenClaimsFromToken(getCookie(cookieName));
}

export function getGravityUserIdFromCookie(cookieName = 'gravity_token'): string | null {
  const payload = getGravityTokenClaimsFromCookie(cookieName);
  return typeof payload?.uid === 'string' && payload.uid ? payload.uid : null;
}

export function getGravityUserStatusFromCookie(cookieName = 'gravity_token'): string | null {
  const payload = getGravityTokenClaimsFromCookie(cookieName);
  return typeof payload?.status === 'string' && payload.status ? payload.status : null;
}

export function getGravityUserPlanFromCookie(cookieName = 'gravity_token'): string | null {
  const payload = getGravityTokenClaimsFromCookie(cookieName);
  return typeof payload?.plan === 'string' && payload.plan ? payload.plan : null;
}

export function getGravityUserRegionFromCookie(cookieName = 'gravity_token'): string | null {
  const payload = getGravityTokenClaimsFromCookie(cookieName);
  return typeof payload?.region === 'string' && payload.region ? payload.region : null;
}

export function getGravityUserOrgIdFromCookie(cookieName = 'gravity_token'): string | null {
  const payload = getGravityTokenClaimsFromCookie(cookieName);
  const orgId = payload?.orgId ?? payload?.org_id;
  return typeof orgId === 'string' && orgId ? orgId : null;
}
